export default "__VITE_ASSET__DpEDg2ih__"